import React, { useEffect } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { getPageContents } from "../../../actions/admin/cmspage";

const Terms = () => {
  const page_name = "cms-terms";
  const dispatch = useDispatch();
  const cmspage_state = useSelector((state) => state.cmspage);
  const { cmspage } = cmspage_state;
  const { i18n } = useTranslation();
  const lang = i18n.language?.toUpperCase();
  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);

  return (
    <FrontLayout>
      {/* <!-- hero --> */}
      <div className="hero-image-terms tw:flex tw:items-end">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none custom-pt-8 tw:mb-4 tw:lg:pb-12">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:flex tw:flex-col tw:justify-end">
            <p
              className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-0 text-gold"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content1
                    : cmspage?.page_content_jp.content1,
              }}
            >
              {/* {t("Pricing")} */}
            </p>
            <h1
              className="tw:font-bold! tw:mb-6 tw:mt-2"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content2
                    : cmspage?.page_content_jp.content2,
              }}
            >
              {/* {t("Pricing.Heading.Three")} */}
            </h1>
            <p
              className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-[58.3333%] tw:md:flex-none text-gold intro tw:mb-12 tw:lg:mb-0"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content3
                    : cmspage?.page_content_jp.content3,
              }}
            >
              {/* {t("Terms.Intro")} */}
            </p>
          </div>
        </div>
      </div>
      {/* <!-- end of hero --> */}
      {/* <!-- section 1 --> */}
      {/* <!-- section 1, general terms --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-[58.3333%] tw:lg:flex-none tw:pb-4 tw:px-4 tw:mt-4 tw:lg:mt-12 tw:pt-12 tw:pb-12 tw:md:px-0">
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:lg:mb-12">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/4 tw:md:flex-none">
            <h5
              className="tw:mb-4"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content4
                    : cmspage?.page_content_jp.content4,
              }}
            >
              {/* {t("Pricing.Heading.Three.Subheading.One")} */}
            </h5>
          </div>
          <div
            className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-3/4 tw:md:flex-none"
            dangerouslySetInnerHTML={{
              __html:
                lang === "EN"
                  ? cmspage?.page_content_en.content5
                  : cmspage?.page_content_jp.content5,
            }}
          >
            {/* <p>{t("Pricing.Heading.Three.Subheading.One.Paragraph.One")}</p>
            <ul>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.One.Paragraph.Two")}{" "}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.One.Paragraph.Three")}{" "}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.One.Paragraph.Four")}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.One.Paragraph.Five")}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.One.Paragraph.Six")}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.One.Paragraph.Seven")}
              </li>
            </ul> */}
          </div>
        </div>
        <hr className="card-line-light-grey"></hr>
        {/* <!-- section 1, airport transfer terms --> */}
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:lg:mb-12 tw:pt-4 tw:md:mt-12 tw:md:pt-0">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-[58.3333%] tw:flex-none tw:md:w-1/4 tw:md:flex-none">
            <h5
              className="tw:mb-4"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content6
                    : cmspage?.page_content_jp.content6,
              }}
            >
              {/* {t("Pricing.Heading.Three.Subheading.Two")} */}
            </h5>
          </div>
          <div
            className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-3/4 tw:md:flex-none"
            dangerouslySetInnerHTML={{
              __html:
                lang === "EN"
                  ? cmspage?.page_content_en.content7
                  : cmspage?.page_content_jp.content7,
            }}
          >
            {/* <p>{t("Pricing.Heading.Three.Subheading.Two.Paragraph.One")}</p>
            <ul>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Two")}{" "}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Three")}{" "}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Four")}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Five")}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Six")}
              </li>
              <li className="tw:my-1">
                {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Seven")}{" "}
                &nbsp;
                <span>
                  <Link className={``} to="./pricing">
                    {t(
                      "Pricing.Heading.Three.Subheading.Two.Paragraph.Seven.Link"
                    )}
                  </Link>
                </span>
                &nbsp;{" "}
                {t(
                  "Pricing.Heading.Three.Subheading.Two.Paragraph.Seven.Part.Two"
                )}
              </li>
            </ul> */}
          </div>
        </div>
        <hr className="card-line-light-grey"></hr>
        {/* <!-- section 1, cancellation policy --> */}
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:lg:mb-12 tw:pt-4 tw:md:mt-12 tw:md:pt-0">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-[58.3333%] tw:flex-none tw:md:w-1/4 tw:md:flex-none">
            <h5
              className="tw:mb-4"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content8
                    : cmspage?.page_content_jp.content8,
              }}
            >
              {/* {t("Cancellation.Policy")} */}
            </h5>
          </div>
          <div
            className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-3/4 tw:md:flex-none"
            dangerouslySetInnerHTML={{
              __html:
                lang === "EN"
                  ? cmspage?.page_content_en.content9
                  : cmspage?.page_content_jp.content9,
            }}
          >
            {/* <p>{t("Pricing.Heading.Three.Subheading.Three.Paragraph.One")}</p>
            <ul>
              <li className="lh-lg">
                {t("Pricing.Heading.Three.Subheading.Three.Paragraph.Two")}{" "}
              </li>
              <li className="lh-lg">
                {t("Pricing.Heading.Three.Subheading.Three.Paragraph.Three")}{" "}
              </li>
              <li className="lh-lg">
                {t("Pricing.Heading.Three.Subheading.Three.Paragraph.Four")}
              </li>
              <li className="lh-lg">
                {t("Pricing.Heading.Three.Subheading.Three.Paragraph.Five")}
              </li>
            </ul> */}
          </div>
        </div>
      </div>
      {/* <!-- section 1 end --> */}
    </FrontLayout>
  );
};

export default Terms;
